import React from 'react';
import { t } from 'i18next';
import { string, func, element, oneOfType, bool, object } from 'prop-types';
import cn from 'classnames';
import { IonIcon } from '@ionic/react';

import CustomButton from '../CustomButton';

import LoadingSpinner from '~components/loadingSpinner';

import styles from './styles.module.scss';

function ErrorMessage({
  action,
  actionButtonText,
  title,
  message,
  className,
  children,
  img: Img,
  imgClassName,
  iconClassName,
  actionButtonLoading,
  secondaryActionButton,
  titleClassName,
  messageClassName,
  actionBtnClassType,
  secondaryTextButton,
  mainButtonIonIcon,
  secondaryButtonIonIcon,
  mainBtnClassName,
  secondaryBtnClassName
}) {
  return (
    <div className={cn('column center middle text-center', styles.container, className)}>
      {iconClassName && <i className={iconClassName} />}
      {Img && <Img className={cn('m-bottom-4', styles.img, imgClassName)} alt={title} />}
      <h3 className={`m-bottom-2 ${styles.title} ${titleClassName}`}>{title}</h3>
      <div className={cn('column full-width', styles.message, messageClassName)}>
        {message && <h4 className="text-base m-bottom-2">{message}</h4>}
        {children}
      </div>
      <div className="column m-top-3">
        {action && (
          <CustomButton
            type="button"
            onClick={action}
            disabled={actionButtonLoading}
            className={cn('m-bottom-2', mainBtnClassName)}
            btnClassType={actionBtnClassType ?? 'outlined'}>
            <LoadingSpinner classNames="m-right-1 m-left-1" isVisible={actionButtonLoading} />
            {mainButtonIonIcon && (
              <IonIcon className={cn('m-right-3', styles.icon)} icon={mainButtonIonIcon} />
            )}
            {actionButtonText}
          </CustomButton>
        )}
        {secondaryActionButton && (
          <CustomButton
            type="button"
            onClick={secondaryActionButton}
            btnClassType="outlined"
            className={cn('m-bottom-2', secondaryBtnClassName)}>
            {secondaryButtonIonIcon && (
              <IonIcon className={cn('m-right-3', styles.icon)} icon={secondaryButtonIonIcon} />
            )}
            {secondaryTextButton || t('Common:cancel')}
          </CustomButton>
        )}
      </div>
    </div>
  );
}

ErrorMessage.defaultProps = {
  actionButtonLoading: false,
  title: t('Error:defaultErrorTitle')
};

ErrorMessage.propTypes = {
  action: func,
  actionBtnClassType: string,
  actionButtonLoading: bool,
  actionButtonText: string,
  className: string,
  iconClassName: string,
  img: oneOfType([element, func, object]),
  // eslint-disable-line react/forbid-prop-types
  imgClassName: string,
  mainBtnClassName: string,
  mainButtonIonIcon: string,
  message: string,
  messageClassName: string,
  secondaryActionButton: func,
  secondaryBtnClassName: string,
  secondaryButtonIonIcon: string,
  secondaryTextButton: string,
  title: string,
  titleClassName: string
};

export default ErrorMessage;
